import {parseISO} from "date-fns";

import {IPriceReportAveragePrices} from "../types/IPriceReportAveragePrices";

const monthFormatter = new Intl.DateTimeFormat("pl-PL", {month: "long", year: "numeric"});

export const formatOfferPricesMonthLabel = (date: string | undefined | null): string | null => {
    if (!date) {
        return null;
    }

    const parsedDate = parseISO(date);

    return Number.isNaN(parsedDate.getTime()) ? null : monthFormatter.format(parsedDate);
};

export const getOfferPricesMonthLabel = (citiesData: IPriceReportAveragePrices[] | null): string | null => {
    return formatOfferPricesMonthLabel(citiesData?.[0]?.date);
};
import {parseISO} from "date-fns";

import {IPriceReportAveragePrices} from "../types/IPriceReportAveragePrices";

const monthFormatter = new Intl.DateTimeFormat("pl-PL", {month: "long", year: "numeric"});

export const formatOfferPricesMonthLabel = (date: string | undefined | null): string | null => {
    if (!date) {
        return null;
    }

    const parsedDate = parseISO(date);

    return Number.isNaN(parsedDate.getTime()) ? null : monthFormatter.format(parsedDate);
};

export const getOfferPricesMonthLabel = (citiesData: IPriceReportAveragePrices[] | null): string | null => {
    return formatOfferPricesMonthLabel(citiesData?.[0]?.date);
};
